/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mCoinAnim.vue?vue&type=template&id=25b0fd35"
import script from "./mCoinAnim.vue?vue&type=script&lang=js"
export * from "./mCoinAnim.vue?vue&type=script&lang=js"
import style0 from "./mCoinAnim.vue?vue&type=style&index=0&id=25b0fd35&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports